<template>
  <div
    class="nav-list"
    @mouseleave="handleLeave"
  >
    <div
      class="nav-list-item"
      v-for="(item, index) in groupedLevelOneList.home"
      :key="item.name"
      :class="[
        { hover: hoverLevelOneId === item.meta.id },
        { active: activeLevelOneId === item.meta.id },
        { bg: hoverLevelOneId === item.meta.id }
      ]"
      @click="handleClickItem(item,index)"
      @mouseenter="handleShowSubList(item, index)"
      @mouseleave="handleHideSubList(item)">
      {{ i18n.t(item.meta.title) }}
      <div
        v-if="activeLevelOneId == item.meta.id"
        class="bottom-line">
      </div>
    </div>
    <div
      id="guide-menu"
      style="display: flex;"
      v-intro="$t('汇入汇款、汇出汇款、路径查询在这里')"
      v-intro-step="1">
      <div
        class="nav-list-item"
        v-for="(item, index) in groupedLevelOneList.huikuan"
        :key="item.name"
        :class="[
          { hover: hoverLevelOneId === item.meta.id },
          { active: activeLevelOneId === item.meta.id },
          { bg: hoverLevelOneId === item.meta.id }
        ]"
        @click="handleClickItem(item,index + groupedLevelOneList.home.length)"
        @mouseenter="handleShowSubList(item, index + groupedLevelOneList.home.length)"
        @mouseleave="handleHideSubList(item)">
        {{ i18n.t(item.meta.title) }}
        <div
          v-if="activeLevelOneId == item.meta.id"
          class="bottom-line">
        </div>
      </div>
    </div>
    <div
      class="nav-list-item"
      v-for="(item, index) in groupedLevelOneList.rest"
      :key="item.name"
      :class="[
        { hover: hoverLevelOneId === item.meta.id },
        { active: activeLevelOneId === item.meta.id },
        { bg: hoverLevelOneId === item.meta.id }
      ]"
      @click="handleClickItem(item, index + groupedLevelOneList.home.length + groupedLevelOneList.huikuan.length)"
      @mouseenter="handleShowSubList(item, index + groupedLevelOneList.home.length + groupedLevelOneList.huikuan.length)"
      @mouseleave="handleHideSubList(item)">
        {{ i18n.t(item.meta.title) }}
      <div
        v-if="activeLevelOneId == item.meta.id"
        class="bottom-line">
      </div>
    </div>
    <transition name="el-zoom-in-top">
      <div
        v-show="showMask"
        class="mask-container"
        @mouseleave="handleHideMask">
        <div
          v-for="item in levelTwoList"
          :key="item.meta.id"
          class="link-item-container">
          <!-- 有多个二级菜单 -->
          <template v-if="levelTwoList.length > 0">
            <NavSubItem :info="item" />
          </template>
          <!-- 只有一个二级菜单 -->
          <!-- <div
            v-else
            class="link-item">
            <div
              v-for="(subItem,index) in item.children"
              :key="index">
              <LinkItem :info="subItem" />
            </div>
          </div> -->
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import i18n from '@/lang'

import { mapMutations, mapState } from 'vuex'
import 'intro.js/introjs.css'
export default {
  data () {
    return {
      i18n
    }
  },
  created () {
  },
  computed: {
    ...mapState('nav', [
      'activeLevelOneId',
      'hoverLevelOneIndex',
      'hoverLevelOneId',
      'levelOneList',
      'levelTwoList',
      'showMask'
    ]),
    groupedLevelOneList () {
      const list = {
        home: [],
        huikuan: [],
        rest: []
      }
      this.levelOneList.forEach(route => {
        if (route.name === 'Home') {
          list.home.push(route)
        } else if (['Inner', 'Outward'].includes(route.name)) {
          list.huikuan.push(route)
        } else {
          list.rest.push(route)
        }
      })
      return list
    }
  },
  methods: {
    ...mapMutations({
      setAll: 'nav/SET_ALL'
    }),
    handleClickItem (item, index) {
      if (item.children && item.children.length) return
      this.setAll({
        activeLevelOneId: item.meta.id,
        hoverLevelOneId: item.meta.id,
        activeLevelThreeId: '',
        hoverLevelOneIndex: index
      })
      this.$router.push({
        name: item.name
      })
    },
    handleShowSubList (item, index) {
      if (item.children) {
        item.showSubList = true
        this.setAll({
          showMask: true,
          levelTwoList: item.children,
          hoverLevelOneId: item.meta.id,
          hoverLevelOneIndex: index
        })
      } else {
        this.setAll({
          levelTwoList: [],
          hoverLevelOneId: item.meta.id,
          showMask: false
        })
      }
    },
    handleHideSubList (item) {
      if (item.meta.id !== this.hoverLevelOneId) {
        item.showSubList = false
      } else {
        item.showSubList = true
      }
    },
    handleShowMask () {
      this.showMask = true
    },
    handleHideMask () {
      if (this.hoverLevelOneId === '' || !this.levelTwoList.length) {
        this.setAll({
          showMask: false,
          hoverLevelOneId: ''
        })
      }
    },
    handleLeave () {
      this.setAll({
        hoverLevelOneId: '',
        levelTwoList: [],
        showMask: false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.nav-list {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: @white;
  font-size: 14px;
  margin-right: 25px;
  &-item {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 64px;
    padding: 0 25px;
    cursor: pointer;
    z-index: 1;

    &.hover {
      color: #fff !important;
      background: @blue;

      &::after {
        top: 0%;
        bottom: 0%;
      }
    }
    &::after {
      position: absolute;
      top: 100%;
      bottom: 0;
      right: 0;
      left: 0;
      content: '';
      width: 100%;
      background: @blue;
      transition: 0.1s linear;
      z-index: -1;
    }
    &.active {
      color: @blueMore;
    }
    &.bg {
      background: @blue;
      color: @white;
    }
    .bottom-line {
      position: absolute;
      bottom: 0;
      left: 0;
      content: '';
      width: 100%;
      height: 4px;
      background: @blue;
    }
  }
  .mask-container {
    position: absolute;
    top: 64px;
    left: 0;
    width: 100%;
    padding: 50px 50px 40px;
    color: @black;
    background: #f0f2f9;
    box-shadow: inset 0px 12px 15px 0px rgba(255, 255, 255, 0.61);
    z-index: 10;
    .link-item-container {
      .link-item {
        display: flex;
        justify-content: center;
        div {
          &:last-child {
            .nav-item {
              margin-right: 0;
            }
          }
        }
      }
      /deep/ .nav-sub-item {
        &.en {
          .nav-item {
            min-width: 241px;
          }
        }
        .nav-item {
          min-width: 100px;
          margin-right: 60px;
          padding-bottom: 40px;
          &:last-child {
            min-width: auto;
          }
        }
      }
      &:last-child {
        /deep/ .nav-sub-item {
          &.en {
            .nav-item {
              min-width: 241px;
              &:first-child {
                padding-bottom: 40px;
              }
            }
          }
          .nav-item {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>

<style lang="less">
.introjs-showElement {
  .nav-list-item {
    color: #131523;
  }
}
</style>
